module.exports = __webpack_public_path__ + "img/qrcode.4d0ee552.png";